export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_05.59f15322.jpg";